import axios from "axios";

export const get_roles = async () => {
    try {
        const res = await axios.get("/system/get_roles");
        return res.data.data;
    }
    catch (err) {
        throw err;
    }
}

export const get_user_list = async () => {
    try {
        const res = await axios.get("/system/get_user_list");
        return res.data.data;
    }
    catch (err) {
        throw err;
    }
}

export const delete_user_profile = async (email: string) => {
    try {
        const res = await axios.post("/system/delete_user_profile", { email });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const modify_role = async (uid: string, values: any) => {
    try {
        const res = await axios.post("/system/modify_role", { uid, values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const delete_role = async (uid: string) => {
    try {
        const res = await axios.post("/system/delete_role", { uid });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const add_role = async (values: any) => {
    try {
        const res = await axios.post("/system/add_role", { values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const get_customers = async () => {
    try {
        const res = await axios.get("/system/get_customers");
        return res.data.data;
    }
    catch (err) {
        throw err;
    }
}

export const modify_customer = async (uid: string, values: any) => {
    try {
        const res = await axios.post("/system/modify_customer", { uid, values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const delete_customer = async (uid: string) => {
    try {
        const res = await axios.post("/system/delete_customer", { uid });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const add_customer = async (values: any) => {
    try {
        const res = await axios.post("/system/add_customer", { values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const get_products = async () => {
    try {
        const res = await axios.get("/system/get_products");
        return res.data.data;
    }
    catch (err) {
        throw err;
    }
}

export const modify_product = async (uid: string, values: any) => {
    try {
        const res = await axios.post("/system/modify_product", { uid, values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const delete_product = async (uid: string) => {
    try {
        const res = await axios.post("/system/delete_product", { uid });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

export const add_product = async (values: any) => {
    try {
        const res = await axios.post("/system/add_product", { values });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}